// libs
import React, { createContext, useCallback, useContext } from 'react';
import LongPressable from 'react-longpressable';
import { noop } from 'lodash';
import _noop from 'lodash/noop';

import useScreen from '@lyearn/core/hooks/useScreen';
import useToggle from '@lyearn/core/hooks/useToggle';
import Platform from '@lyearn/core/utils/Platform';

// types
type LongPressContextType = {
  isLongPress: boolean;
  on: () => void;
  off: () => void;
};

export const LongPressContext = createContext<LongPressContextType>({
  isLongPress: false,
  on: noop,
  off: noop,
});

export const useLongPressed = () => {
  const value = useContext(LongPressContext);

  return value;
};

// The context provider is only for mobile web
export const LongPressProviderWeb: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [isLongPress, { on, off }] = useToggle(false);
  const value = React.useMemo(() => ({ isLongPress, on, off }), [isLongPress, on, off]);
  const { isMobile } = useScreen();
  const isWeb = Platform.OS === 'web';

  const onLongPress = useCallback(
    (ev: any) => {
      ev.preventDefault();
      ev.stopPropagation();
      on();
    },
    [on],
  );

  // For native devices we directly use the Pressable inside the Link component to long press
  if (!isMobile || !isWeb) {
    return <>{children}</>;
  }

  return (
    <LongPressable
      // @ts-ignore
      style={{ flex: 1, height: '100%', width: '100%' }}
      onLongPress={onLongPress}
      onShortPress={_noop}>
      <LongPressContext.Provider value={value}>{children}</LongPressContext.Provider>
    </LongPressable>
  );
};
